import { createAction, props } from '@ngrx/store';

export const retrievedIntegrations = createAction(
  '[API] Retrieve Integrations Success',
  props<{ integrations: any[] }>()
);
